// Config
import firebaseConfig from "./config";
// Services
import { initializeApp, getApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithCredential,
  signOut,
  sendPasswordResetEmail,
  updatePassword,
  updateProfile,
  GoogleAuthProvider,
  linkWithPopup,
  unlink,
  connectAuthEmulator,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  onSnapshot,
  getDocs,
  getDoc,
  documentId,
  doc,
  FieldPath,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  or,
  and,
  limit,
  orderBy,
  serverTimestamp,
  Timestamp,
  FieldValue,
  runTransaction,
  writeBatch,
  deleteField,
  increment,
  arrayUnion,
  arrayRemove,
  startAt,
  startAfter,
  GeoPoint,
  getCountFromServer,
  connectFirestoreEmulator,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  uploadString,
  getDownloadURL,
  getMetadata,
  getBytes,
  deleteObject,
  connectStorageEmulator,
} from "firebase/storage";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
// import {
//   getMessaging,
//   getToken,
//   onMessage,
//   deleteToken,
// } from "firebase/messaging";

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const firestore = getFirestore();
const storage = getStorage();
const functions = getFunctions(getApp());
const remoteConfig = getRemoteConfig();
// const messaging = getMessaging(app);

if (process.env.VUE_APP_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
} else if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

// Dev-only helper for admin console scripts (e.g. provisionApiKey) — uses this tab's auth session.
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  window.__mytraceCallable = (name) => httpsCallable(functions, name);
}

// onMessage(messaging, (payload) => {
//   const notificationTitle = payload.notification.title;
//   const notificationOptions = {
//     body: payload.notification.body,
//     click_action: payload.notification?.fcmOptions?.link || ""
//   };

//   new Notification(notificationTitle, notificationOptions)
// })

export {
  // Auth
  auth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithCredential,
  sendPasswordResetEmail,
  updatePassword,
  updateProfile,
  GoogleAuthProvider,
  linkWithPopup,
  unlink,
  // Firestore
  firestore,
  collection,
  onSnapshot,
  getDocs,
  getDoc,
  doc,
  FieldPath,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  or,
  and,
  limit,
  orderBy,
  serverTimestamp,
  Timestamp,
  FieldValue,
  documentId,
  runTransaction,
  writeBatch,
  deleteField,
  increment,
  arrayUnion,
  arrayRemove,
  startAt,
  startAfter,
  GeoPoint,
  getCountFromServer,
  // Storage
  storage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  uploadString,
  getDownloadURL,
  getMetadata,
  getBytes,
  deleteObject,
  // Functions
  functions,
  connectFunctionsEmulator,
  httpsCallable,
  // Remote Config
  remoteConfig,
  fetchAndActivate,
  getValue,
  // Messaging
  // messaging,
  // getMessaging,
  // getToken,
  // onMessage,
  // deleteToken
};
